import { getCampaignPerformanceAnalytics } from "@redotech/redo-merchant-marketing-rpc/schema/get-campaign-performance-analytics";
import * as z from "zod";

export const getTeamCampaignPerformance = {
  name: "getTeamCampaignPerformance" as const,
  input: getCampaignPerformanceAnalytics.input.extend({
    teamId: z.string(),
    userId: z.string(),
  }),
  output: getCampaignPerformanceAnalytics.output,
};
